
/**
 * ToString
 * @param params
 * @returns {*}
 */
function fnToString(obj) {
	if (obj == undefined || obj == "undefined" || obj == null || obj == "null") {
		return "";
	} else {
		return obj.toString().trim();
	}
}

/**
 * ToInt
 * @param params
 * @returns {*}
 */
function fnToInt(str) {
	if (str != undefined && str != "" && str != null) {
		str = str.toString().replace(/[^0-9]/gi, "");
		if (Number.isInteger(str)) {
			return 0;
		} else {
			return parseInt(str, 10);
		}
	} else {
		return 0;
	}
}

export {
	fnToString,
	fnToInt,
}
